module.exports = __webpack_public_path__ + "img/weixinpay.67173b07.jpg";